import { Component } from "react"

/* REST API */
import { currency, removeCurrency as remove } from "../../api/Table"

/* Widgets */
import Layout from "./Layout"
import CurrencyForm from "./CurrencyForm"

/* Components */
import { pushToast } from "../../components/Toast"
import { pushConfirm } from "../../components/Confirm"

/* Icons */
import { CurrencyIcon, ChipIcon, EditIcon, TrashIcon, PlusIcon, CheckIcon } from "../../components/Icons"

/* Redux */
import { connect } from "react-redux"

/* Translate */
import { t } from "../../translates/translate"

/* Helpers */
import { utils } from "../../helpers"


/* Widget Currency */
class Currency extends Component {

    constructor() {
        super()

        this.state = {
            status: "loading",
            data: [],
            currencies: [],
        }
    }

    componentDidMount = () => {
        this.load()
    }

    /* Load Currencies Of The Table */
    load = (reload = false) => {

        /* Fields */
        const { uid } = this.props

        /* Check Params */
        if (!uid) {
            this.setState({ status: "error", data: [] })
            return
        }

        /* Refresh the page if necessary */
        if (reload) {
            this.setState({ status: "loading" })
        }

        /* START REST API */
        currency({ uid }).then((response) => {
            if (response.status === 200) {
                this.setState({ status: "ok", data: response.data.list, currencies: response.data.currencies })
            }
            else if (response.status === 401 || response.status === 403) {
                this.setState({ status: "permission", data: [] })
            }
            else if (response.status === 498) {
                this.setState({ status: "key", data: [] })
            }
            else {
                this.setState({ status: "error", data: [] })
            }
        }).catch(() => {
            this.setState({ status: "network", data: [] })
        })

    }

    /* Read The Error Message Of A Response */
    message = (response) => {

        if (response && (response.status === 401 || response.status === 403)) {
            return t("swal.noAccess")
        }

        if (response && response.status === 498) {
            return t("swal.invalidKey")
        }

        return t("swal.generic")
    }

    /* THE CURRENCIES THAT ARE NOT ON THE TABLE YET */
    getFree = () => {

        /* Fields */
        const { data, currencies } = this.state

        /* Send Result */
        return currencies.filter((item) => !data.some((added) => parseInt(added.currencyID) === parseInt(item.id)))
    }

    /* Remove Action */
    remove = (item) => {

        /* Fields */
        const { uid } = this.props

        /* Check Params */
        if (!uid) {
            pushToast({ text: t("widget.unknownError"), type: "error" })
            return
        }

        /* Ask */
        pushConfirm({
            title: t("swal.deleteConfirm"),
            text: `${item.name} (${item.code})`,
            icon: "warning",
            danger: true,
            confirmText: t("swal.deleteButton"),
            cancelText: t("swal.cancelButton"),
        }).then((confirmed) => {

            /* Check Answer */
            if (!confirmed) {
                return
            }

            /* START REST API */
            remove({ uid, id: item.id }).then((response) => {
                if (response.status === 200) {
                    this.setState((state) => ({ data: state.data.filter((row) => parseInt(row.id) !== parseInt(item.id)) }))
                    pushToast({ text: t("currency.deletedSuccess"), type: "success" })
                }
                else {
                    pushToast({ text: this.message(response), type: "error" })
                }
            }).catch(() => {
                pushToast({ text: t("swal.generic"), type: "error" })
            })

        })

    }


    /* Draw One Limit Of A Currency */
    _cell = (label, value, item) => (
        <div className="tbl--cur-cell">
            <span>{label}</span>
            <p>{`${utils.checkValue(value)}`.trim() === "" ? "—" : utils.convertor(value, item.symbol, item.isAfter)}</p>
        </div>
    )

    /* Draw The Chips Of A Currency */
    _chips = (item) => {

        /* Fields */
        const chips = `${utils.checkValue(item.chips)}`.split(",").map((chip) => chip.trim()).filter((chip) => chip !== "")

        /* Check Chips */
        if (chips.length === 0) {
            return null
        }

        return (
            <div className="tbl--cur-chips">

                <span><ChipIcon size={12} />{t("currency.chipsLabel")}</span>

                <div className="tbl--cur-chip-list">
                    {chips.map((chip, index) => <div className="tbl--cur-chip" key={`${index}`}>{chip}</div>)}
                </div>

            </div>
        )
    }

    /* Draw One Currency Of The Table */
    _currency = (item, index) => {

        /* Fields */
        const { blackjack } = this.props

        return (
            <div className="tbl--cur" key={`${index}`}>

                <div className="tbl--cur-head">

                    <div className="tbl--cur-badge">{utils.checkValue(item.symbol, item.code)}</div>

                    <div className="tbl--cur-text">
                        <h3>{item.name}</h3>
                        <p>{item.code}</p>
                    </div>

                    <div className="tbl--cur-actions">

                        <div onClick={() => this._form.open({ type: "edit", item })} className="tbl--cur-action" title={t("currency.edit")}>
                            <EditIcon size={15} />
                        </div>

                        <div onClick={() => this.remove(item)} className="tbl--cur-action red" title={t("currency.delete")}>
                            <TrashIcon size={15} />
                        </div>

                    </div>

                </div>

                <div className="tbl--cur-grid">
                    {this._cell(t("currency.minBetShort"), item.min, item)}
                    {this._cell(t("currency.maxBetShort"), item.max, item)}
                    {this._cell(t("currency.maxPayShort"), item.maxPay, item)}
                    {this._cell(t("currency.maxBonusShort"), item.maxBonus, item)}
                </div>

                {/* Side Bets Of A Blackjack */}
                {blackjack &&
                    <div className="tbl--cur-grid">
                        {this._cell("PERFECT PAIR", item.maxPerfectPair, item)}
                        {this._cell("21+3", item.maxTwentyOne, item)}
                        {this._cell("BUST", item.maxBust, item)}
                        {this._cell("CRAZY SEVEN", item.maxCrazySeven, item)}
                    </div>
                }

                {/* Draw Chips */}
                {this._chips(item)}

            </div>
        )
    }

    render = () => {

        /* Fields */
        const { uid, blackjack } = this.props
        const { status, data, currencies } = this.state

        /* Layout */
        if (status !== "ok") {
            return <Layout status={status} reload={() => this.load(true)} />
        }

        /* Fields */
        const free = this.getFree()

        return (
            <div className="tbl--panel">

                <div className="tbl--section">

                    <div className="tbl--section-title">
                        <CurrencyIcon size={14} />
                        {t("currency.title")}
                        <span className={`tbl--counter ${data.length === 0 ? "empty" : ""}`}>{data.length}</span>
                    </div>

                    {/* Currencies */}
                    {data.map((item, index) => this._currency(item, index))}

                    {/* Empty List */}
                    {data.length === 0 && <div className="tbl--empty">{t("currency.emptyOnTable")}</div>}

                </div>

                <div className="tbl--footer">

                    {free.length === 0
                        ? <div className="tbl--button ghost disabled"><CheckIcon size={13} />{t("currency.allAdded")}</div>
                        : <div onClick={() => this._form.open({ type: "create" })} className="tbl--button primary"><PlusIcon size={15} />{t("currency.addTitle")}</div>
                    }

                </div>

                {/* The form of one currency — it opens above the panel */}
                <CurrencyForm
                    ref={(ref) => this._form = ref}
                    uid={uid}
                    blackjack={blackjack}
                    currencies={currencies}
                    added={data}
                    reload={() => this.load()}
                />

            </div>
        )
    }

}

const mapStateToProps = (state) => ({
    language: state.language,
})

export default connect(mapStateToProps)(Currency)
